<template>
  <v-expand-transition>
    <v-card v-if="selectedUser" flat>      
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">        
        <h5>Roll</h5>
        <v-select
          v-model="selectedUser.userRoleId"
          :items="userRoles"
          outlined
          class="mt-3"
          :disabled="selectedUser.id && selectedUser.id === currentUser.id || currentUser.userrole.isAdmin!=true"
          :rules="[rules.required]"
        ></v-select>
        <p v-if="selectedRole === 'region'">
          <b>Användaren får behörighet att både visa, skapa, ändra och radera information och ärenden i valda regioner.</b>
        </p>
        <p v-if="selectedRole === 'viewer'">
          <b>Användaren får behörighet att visa information och ärenden i valda regioner.</b>
        </p>

        <v-select
          v-if="['viewer', 'region'].includes(selectedRole)"
          v-model="selectedUser.regionIds"
          :items="items"
          chips
          outlined
          multiple
          class="mt-3"
          :disabled="selectedUser.id && selectedUser.id === currentUser.id"
          :rules="[rules.requiredIf(['viewer', 'region'].includes(selectedRole),selectedUser.regionIds.length)]"
        >
          <template v-slot:selection="{ attrs, item, selected }">
            <v-chip
              class="clear-chips-icon"
              close-icon="$sl-close"
              v-bind="attrs"
              :input-value="selected"
              close
              @click:close="remove(item)"
            >{{ item.text }}</v-chip>
          </template>
        </v-select>          

        <v-card-actions class="justify-space-between no-margins mt-4">
          <v-btn :disabled="!canSave" @click="saveCompetence">
            <v-icon>$sl-check</v-icon>Spara
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-expand-transition>
</template>
<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'

// @group Person
export default {
  name: 'UserInformation',

  mixins: [RulesMixin],

  props: {
    // An array of the roles available for the v-select
    userRoles: {
      type: Array,
      // The default value is: `empty array`
      default: []
    },
    canSave: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: true,
      lazy: false,
      items: []
    }
  },
  created() {
    this.items = this.basicRegions.map(o => {
      return {value: o.id, text: o.name}
    })
  },

  computed: {
    ...mapGetters('basic', ['basicRegions']),
    ...mapGetters('user', ['selectedUser']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserObj']),

    selectedRole(){
      const selectedUserRole = this.userRoles.find(userRole => userRole.value === this.selectedUser.userRoleId)
      if(!selectedUserRole) {
        return;
      }

      return selectedUserRole.role
    }
  },
  methods: {
    ...mapActions('user', ['setSelectedUser']),

    remove(item) {
      this.selectedUser.regionIds.splice(this.selectedUser.regionIds.indexOf(item), 1)
      this.selectedUser.regionIds = [...this.selectedUser.regionIds]
    },
    async saveCompetence() {
      if (
        this.selectedUser &&
        !this.$refs.form.validate()
      ) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }

      let found = this.userRoles.find(f => f.value == this.selectedUser.userRoleId)
      if (found && found.text)
        await this.setSelectedUser({ ...this.selectedUser, ...{ userrole: { name: found.text } } })
      
      this.$emit('saveuser', this.selectedUser)
    }
  }
}
</script>

<style>
</style>